import React from "react";

function notFound() {
  return <div className="text-3xl md:text-5xl p-20 md:text-center dark:text-white">404 not found.</div>;
}

export default notFound;
